import { FC, useEffect, useState } from 'react'
import { Table } from 'reactstrap'
import classnames from 'classnames'

import { ShiftConceptPlanningResource } from '../../../../entities/ShiftConceptPlanning/ShiftConceptPlanning'
import {
    Absence,
    LeaveOfAbsenceResource,
    PreferToWorkTimeSlot,
    ShiftPlanning,
    SpecialDayViewModel,
    UnavailableToWorkTimeSlot,
    UserWithConceptAvailability,
} from '../../../../models'
import ListViewTableHead from '../ListViewTable/subcomponents/ListViewTableHead/ListViewTableHead'
import ConceptsListViewUser from './subcomponents/ConceptsListViewUser/ConceptsListViewUser'

import './ConceptsListViewTable.scss'

export type ResourceTypes = LeaveOfAbsenceResource
| Absence
| PreferToWorkTimeSlot
| UnavailableToWorkTimeSlot
| ShiftConceptPlanningResource
| ShiftPlanning;

interface ConceptsListViewTableProps {
    isLoading: boolean;
    isFilterEmploymentTypeBadgeActive: boolean;
    canAddPlannings: boolean;
    isFirstRowSticky: boolean;
    isFirstColumnSticky: boolean;
    days: Date[];
    specialDays?: SpecialDayViewModel[];
    startDate: Date;
    endDate: Date;
    users: UserWithConceptAvailability[];
    onAvailabilityClick: (resources: ResourceTypes) => void;
    onAddButtonClick: (date: Date, user: UserWithConceptAvailability) => void;
}

const ConceptsListViewTable: FC<ConceptsListViewTableProps> = ({
    isLoading,
    days,
    specialDays = [],
    isFilterEmploymentTypeBadgeActive,
    canAddPlannings,
    isFirstRowSticky,
    isFirstColumnSticky,
    onAvailabilityClick,
    onAddButtonClick,
    ...props
}) => {
    const classNames = classnames('concepts-list-view-table table-container-responsive', {
        'concepts-list-view-table--first-row-sticky': isFirstRowSticky,
        'concepts-list-view-table--first-column-sticky': isFirstColumnSticky,
    })

    const [users, setUsers] = useState<UserWithConceptAvailability[]>(props.users || [])

    useEffect((): void => {
        if (! isLoading && props.users.length) {
            setUsers(props.users)
        }
    }, [props.users, isLoading])

    return (
        <div className={classNames}>
            <div className="table-container concepts-list-view-table__table-container">
                <Table className="concepts-list-view-table__table">
                    <ListViewTableHead
                        dates={days}
                        specialDays={specialDays}
                        className="concepts-list-view-table__table-head"
                    />

                    <tbody className="concepts-list-view-table-body">
                        {users.map(user => (
                            <ConceptsListViewUser
                                key={user.id}
                                isLoading={isLoading}
                                user={user}
                                range={days}
                                isFilterEmploymentTypeBadgeActive={isFilterEmploymentTypeBadgeActive}
                                canAddPlannings={canAddPlannings}
                                onAvailabilityClick={onAvailabilityClick}
                                onAddButtonClick={onAddButtonClick}
                            />
                        ))}
                    </tbody>
                </Table>
            </div>
        </div>
    )
}

export default ConceptsListViewTable
